import { useLanguage } from "../context/LanguageContext";

const Marquee = () => {
  const { languages } = useLanguage();
  const items = [...languages, ...languages];

  return (
    <div
      className="relative overflow-hidden border-y border-sky-100 bg-gradient-to-r from-sky-50 via-white to-amber-50 py-5"
      data-testid="language-marquee"
    >
      <div className="animate-marquee flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((l, i) => (
          <span key={`${l.code}-${i}`} className="flex items-center gap-10">
            <span
              className={`font-heading text-lg font-bold tracking-wide ${
                i % 2 === 0 ? "text-sky-700" : "text-amber-600"
              }`}
            >
              {l.nativeName}
            </span>
            <span className="h-1.5 w-1.5 rounded-full bg-amber-400" />
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
